import React, { useState, useEffect } from "react";
import {
  Text,
  View,
  TouchableOpacity,
  Linking,
  Image,
  ScrollView,
  Dimensions,
} from "react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";
import api from "../../services/api";
import { FormattedMessage } from "react-intl";
import { useRoute } from "@react-navigation/native";
import HeaderTabs from "../../components/HeaderTabs";
import HeaderInfoCoin from "../../components/HeaderInfoCoin";
import ScreenLoader from "../../components/ScreenLoader";
import { If, Then, Else } from "react-if";
import { decode } from "html-entities";
import GobackButton from "../../components/GoBackButton";
import styles from "./styles";
import InfoCardLoteAgro from "../../components/InfoCardLoteAgro";
import LoteAvaliacao from "../../components/LoteAvaliacao";

const MoreInfosCoin = () => {
  const route = useRoute();
  const [dataCoin, setDataCoin] = useState([]);
  const [clientCountry, setClientCountry] = useState("");
  const [lang, setLang] = useState("");
  const [loading, setLoading] = useState(true);
  const [description, setDescription] = useState("");
  const [translatedNameToken, setTranslatedNameToken] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [idCoin, setIdCoin] = useState("");
  const currentUrl = window.location.href;

  const [isSmallScreen, setIsSmallScreen] = useState(
    Dimensions.get("window").width < 768
  );

  useEffect(() => {
    const handleResize = () => {
      const width = Dimensions.get("window").width;
      setIsSmallScreen(width < 768);
    };

    const subscription = Dimensions.addEventListener("change", handleResize);
    return () => {
      subscription?.remove();
    };
  }, []);

  const imageArray = {
    Solar: require("../../../assets/solar_banner.png"),
    Eólico: require("../../../assets/eolica_banner.png"),
    Hidroelétrico: require("../../../assets/hidroeletrica_banner.png"),
    Biomassa: require("../../../assets/biomassa_banner.png"),
    Carbono: require("../../../assets/carbono_banner.png"),
    GpxAgro: require("../../../assets/gpx_agro_banner.jpeg"),
    SelosCarbonoNeutro: require("../../../assets/selos_banner.jpeg"),
  };

  const decodeHtml = (html) => {
    return decode(html);
  };

  useEffect(() => {
    getClientCountry();
    getLang();
  }, []);

  const getClientCountry = async () => {
    const country = await AsyncStorage.getItem("client_country");
    setClientCountry(country);
    return country;
  };

  const getLang = async () => {
    const lang = await AsyncStorage.getItem("lang");
    setLang(lang);
    return lang;
  };

  const getDataCoin = async (idCoin, country, lang) => {
    const token = await AsyncStorage.getItem("JWT_TOKEN");
    setLoading(true);

    try {
      const res = await api.get(`/actives/${idCoin}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setDataCoin(res.data);
      if (res.data.actives && res.data.actives[0].description) {
        const translatedDescription = await translate(
          res.data.actives[0].description,
          country,
          lang
        );
        setDescription(translatedDescription);

        const nameToken = res.data.actives[0].name_token;
        if (nameToken.includes("USE")) {
          setTranslatedNameToken(nameToken);
        } else {
          const translatedName = await translate(nameToken, country, lang);
          setTranslatedNameToken(translatedName);
        }
      }
    } catch (error) {
      console.error("Error fetching coin data:", error);
    } finally {
      setLoading(false);
    }
  };

  const translate = async (texto, country, lang) => {
    if (country === "brasil" && lang === "pt-BR") {
      return texto;
    } else if (country === "italia" || lang === "it") {
      try {
        const token = await AsyncStorage.getItem("JWT_TOKEN");
        const response = await api.post(
          `/language-translation`,
          {
            text: texto,
            target_language: "it",
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        return response?.data?.translation || texto;
      } catch (error) {
        return texto;
      }
    } else if (lang === "en") {
      try {
        const token = await AsyncStorage.getItem("JWT_TOKEN");
        const response = await api.post(
          `/language-translation`,
          {
            text: texto,
            target_language: "en",
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        return response?.data?.translation || texto;
      } catch (error) {
        return texto;
      }
    }

    return texto;
  };

  useEffect(() => {
    if (idCoin && categoryName) {
      Promise.all([getClientCountry(), getLang()]).then(([country, lang]) => {
        getDataCoin(idCoin, country, lang);
        setCategoryName(categoryName);
      });
    }
  }, [idCoin, categoryName]);

  useEffect(() => {
    if (route.params?.id) {
      Promise.all([getClientCountry(), getLang()]).then(([country, lang]) => {
        getDataCoin(route.params.id, country, lang);
        setIdCoin(route.params?.id);

        if (route.params?.categoryName) {
          setCategoryName(route.params.categoryName);
        }
      });
    }
  }, [route.params?.id]);

  /*  useEffect(() => {
    if (categoryName) {
    }
  }, [categoryName]); */

  const openFile = async (path) => {
    let url = `https://filesgpx.s3.us-east-2.amazonaws.com/${path}`;
    const supported = await Linking.canOpenURL(url);
    if (supported) {
      await Linking.openURL(url);
    }
  };

  const getImageForToken = () => {
    const tokenName = translatedNameToken;
    if (!categoryName || categoryName.trim() === "") {
      console.warn("categoryName is empty or undefined");
      return null;
    }

    if (tokenName.includes("Solar")) return imageArray.Solar;
    if (tokenName.includes("Eólico")) return imageArray.Eólico;
    if (tokenName.includes("Hidroelétrico")) return imageArray.Hidroelétrico;
    if (tokenName.includes("Biomassa")) return imageArray.Biomassa;
    if (tokenName.includes("LTT")) return imageArray.Carbono;

    if (categoryName === "GPX Agro") return imageArray.GpxAgro;
    if (categoryName.includes("Selo")) return imageArray.SelosCarbonoNeutro;

    return null;
  };

  return (
    <>
      <ScreenLoader loading={loading} />
      <ScrollView>
        <View
          style={{
            flexDirection: isSmallScreen ? "column" : "row",
            marginTop: "5%",
            width: "80%",
            marginLeft: "10%",
          }}
        >
          <View style={styles.contRastreioVoltar}>
            <Image
              source={getImageForToken()}
              style={
                (styles.imageBanners,
                {
                  height: isSmallScreen ? 310 : 515,
                  marginTop: isSmallScreen ? 180 : 110,
                })
              }
            />
            <If
              condition={
                currentUrl.includes("homol.gpxecofi.com.br") ||
                currentUrl.includes("localhost")
              }
            >
              <Then>
                <TouchableOpacity
                  style={styles.btnRastreabilidade}
                  onPress={() =>
                    Linking.openURL(
                      "https://crop-monitoring.eos.com/analytics/field/10345094?period_from=2025-01-01&period_to=2025-04-09"
                    )
                  }
                >
                  <Text style={{ color: "#FFF" }}>
                    <FormattedMessage id="moreInfosCoin.btnTxtRastreabilidade" />
                  </Text>
                </TouchableOpacity>
              </Then>
            </If>

            <GobackButton
              style={{
                maxWidth: 310,
                height: 38,
                width: isSmallScreen ? "100%" : 310,
              }}
            />
          </View>

          <View
            style={[
              styles.mainContainer,
              { width: isSmallScreen ? "100%" : "60%" },
            ]}
          >
            <HeaderTabs
              title={<FormattedMessage id="moreInfosCoin.headerTabsTitle" />}
              containerStyle={{ marginLeft: 0, marginBottom: 12 }}
            />
            <HeaderInfoCoin dataCoin={dataCoin} />
            <View style={styles.circulationContent}>
              <If
                condition={
                  dataCoin.actives !== undefined &&
                  dataCoin.actives.length > 0 &&
                  !dataCoin.actives[0].cryptoactive
                }
              >
                <Then>
                  <View style={styles.containerImgNameToken}>
                    <Text style={styles.titleCirculation}>
                      <FormattedMessage id="headerinfocoin.emCirculacao" />
                    </Text>
                    <Text style={styles.amountCirculation}>
                      {dataCoin?.count} {translatedNameToken}
                    </Text>
                  </View>
                </Then>
                <Else> {null}</Else>
              </If>
            </View>
            <View style={styles.descriptionContainer}>
              <Text style={styles.titleDescription}>
                <FormattedMessage id="moreInfosCoin.descricao" />
              </Text>
              <Text style={styles.contentDescription}>
                {decodeHtml(description)}
              </Text>
            </View>

            <View style={styles.containerFiles}>
              <Text style={styles.titleDescriptionFiles}>
                <FormattedMessage id="moreInfosCoin.arquivos" />
              </Text>

              {dataCoin.files_actives !== undefined
                ? dataCoin.files_actives
                    .filter((item) => {
                      if (clientCountry === "italia" || lang === "it") {
                        return item.name.includes("italiano");
                      } else {
                        return !item.name.includes("italiano");
                      }
                    })
                    .map((item, index) => (
                      <TouchableOpacity
                        key={index}
                        style={styles.contentFiles}
                        onPress={() => {
                          openFile(item.path);
                        }}
                      >
                        <Image
                          source={require("../../../assets/pdf-download.svg")}
                          style={styles.imgDownload}
                        />
                        <Text
                          style={[
                            styles.nomeArquivo,
                            { maxWidth: isSmallScreen ? "85%" : "100%" },
                          ]}
                        >
                          {item.name.toLowerCase().replace(/[\s-]+/g, "_")}
                        </Text>
                      </TouchableOpacity>
                    ))
                : null}
            </View>

            <If
              condition={
                categoryName &&
                categoryName === "GPX Agro" &&
                (currentUrl.includes("homol.gpxecofi.com.br") ||
                  currentUrl.includes("localhost"))
              }
            >
              <Then>
                <View
                  style={{
                    flexDirection: isSmallScreen ? "column" : "row",
                    flexWrap: "wrap",
                  }}
                >
                  <InfoCardLoteAgro idCoin={idCoin} />
                  <LoteAvaliacao />
                </View>
              </Then>
            </If>
          </View>
        </View>
      </ScrollView>
    </>
  );
};

export default MoreInfosCoin;
